import OktaAuth from "@okta/okta-auth-js";

export const oktaSignInConfig = {
  baseUrl: '',
  clientId: '',
  redirectUri: window.location.origin + '/login/callback',
  logo: '',
  authParams: {
    // If your app is configured to use the Implicit Flow
    // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
    // you will need to uncomment the below line
    // pkce: false
    issuer: '',
    scopes: [
      "openid",
      "profile",
      "email",
      "address",
      "phone"
    ],
    responseType:  ['id_token','token']
  }
};

export const oktaAuthConfig: any = {
  // Note: If your app is configured to use the Implicit Flow
  // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
  // you will need to add `pkce: false`

  issuer: '',
  clientId: '',
  redirectUri: window.location.origin + '/login/callback',
  pkce: true,
  disableHttpsCheck: true
};

export let oktaAuth: any;

export const initOktaInstance = (config: any) => {
  oktaAuthConfig.issuer = config.issuer;
  oktaAuthConfig.clientId = config.clientId;
  oktaSignInConfig.baseUrl = config.issuer;
  oktaSignInConfig.clientId = config.clientId;
  oktaSignInConfig.logo = config.logo;
  oktaSignInConfig.authParams.issuer = config.issuer;
  oktaAuth = new OktaAuth(oktaAuthConfig);
}
